export default "__VITE_ASSET__DVpfMtbr__"